import axios from 'axios';
 
const api=axios.create({
    baseURL:'https://darkcyan-okapi-381663.hostingersite.com/api/', 
    // baseURL:'http://127.0.0.1:8000/api/', 

    withCredentials:true,
    headers:{
            'Accept':'application/json',
              'Content-Type':'application/json'}
});

export default api;